import async from 'async';
import _get from 'lodash/get';

import get from 'utils/request/get';
import { IS_PPP, getDomain } from 'utils/appType';
import user from 'utils/extra/user';
import getRetailerOverride from 'utils/methods/getRetailerOverride';
import loadCSSVariablesPolyfill from 'config/polyfills/cssVariables';

// Fetch store properties for retailer
export default function fetchStoreProperties(success, error) {
  const params = {};

  if (IS_PPP) {
    const { sellerID, storeID } = user.getPPPIdsFromURL();
    if (sellerID) params.sellerID = sellerID;
    if (storeID) params.storeID = storeID;
  } else {
    const retailer = getRetailerOverride();
    if (retailer) {
      params.retailer = retailer;
    } else {
      params.domain = getDomain();
    }
  }

  async.retry(
    {
      times: 3,
      interval: 3000,
      errorFilter: (err) => _get(err, 'statusCode') !== 404,
    },
    (callback) => {
      get('/customer/storeProperties/', { isPublic: true, params })
        .then((data) => callback(null, data))
        .catch((e) => callback(e, null));
    },
    function (err, result) {
      if (err) {
        const errorObject = new Error(`GET Store properties Failed: ${params}`);
        errorObject.source = 'storeProperties';
        errorObject.searchParams = params;
        errorObject.statusCode = _get(err, 'statusCode');
        error(errorObject);
      } else {
        const data = _get(result, 'data');
        if (!data) {
          throw new Error('No data to process');
        }
        loadCSSVariablesPolyfill(JSON.stringify(data));
        success(JSON.stringify(data));
      }
    },
  );
}
